angular.module('FlexyBeautyApp.services')
    .factory('SaleStatus', function () {
        let saleStatus = {
            CREATED: "created",
            ESTIMATION: "estimation",
            WAITING: "waiting",
            ADVANCE: "advance",
            ADVANCE_PROCESS: "advanceProcess",
            ADVANCE_KEEPED: "advanceKeeped",
            SOLD_PROCESS: "soldProcess",
            CANCELED: "canceled",
            CREDIT: "credit",
            SOLD: "sold"
        };
        return saleStatus;
    });



// WEBPACK FOOTER //
// ./js/services/views/ConstantsSaleStatus.js